export default __webpack_public_path__ + "static/media/pattternlarge.17e37ebb.png";